import type { OutstandingItem } from './outstanding.schema';

/**
 * The file a director is actually putting their signature on.
 *
 * Mirrors `signableDocumentIdOf`: an annual review is signed by signing its
 * solvency resolution, so the resolution's file is the one to show. Showing
 * `item.fileURL` there would put the annual review notice on screen while the
 * signature landed on a different document — the exact mismatch the id helper
 * exists to prevent, reintroduced visually.
 *
 * Empty when the document has not been rendered yet; the feed sends a null
 * `fileURL` in that window and the schema flattens it to ''.
 */
export const signableDocumentUrlOf = (item: OutstandingItem): string => {
  // Branch on the same condition `signableDocumentIdOf` branches on, not on
  // whether the resolution happens to have a file. Falling back to
  // `item.fileURL` independently is the mismatch this helper exists to
  // prevent: an item can carry a solvency id while its `fileURL` is still
  // null — the feed sends that while the resolution is being rendered — and
  // the two helpers would then disagree, putting the annual review notice on
  // screen while the signature landed on the resolution. When the resolution
  // is the document being signed, it is the only document worth showing;
  // empty is the honest answer until it exists.
  const solvencyId = item.solvency?.id ?? '';
  if (solvencyId !== '') return item.solvency?.fileURL ?? '';

  return item.fileURL;
};
